import {
    getAxios,
    formDataToRequestParams,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberMessageDialog(params = {}) {
    let axios = getAxios();

    console.log(params);

    return axios.request({
        url: '/member/messages/conversation/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}

export function sendMemberMessageToDialog(data = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/messages/send/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}

export function deleteMemberMessageToDialog(data = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/messages/action/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberMessageDialog.js